import React from 'react';
import { useFormik } from 'formik';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import MenuItem from '@mui/material/MenuItem';
import validationSchema from './validationSchema';
import Checkbox from '@mui/material/Checkbox';
import secondStepData from './secondStepData';
import FileUploadViewer from 'views/NotFoundCover/FileUploadViewer';
import uploadStudentDetailsService from '../NotFoundCover/uploadStudentDetailsService';
import uploadFileService from '../NotFoundCover/uploadFileService';

const SecondStep = ({ handleCurrentStep, secondState, initialState }) => {
  let isDisabled = true;

  // const [fatherDetailsUploadedTime, setFatherDetailsUploadedTime] = useState(null);

  const onSubmit = () => {
    // localStorage.form1Values = JSON.stringify(formik.values);
    handleCurrentStep(3, formik.values);
    const data = { ...initialState, ...formik.values };
    uploadStudentDetailsService(data);
    if (formik.values.compPhoto) {
      uploadFileService('fatherCertificate', formik.values.compPhoto);
    }
    if (formik.values.compPhoto1) {
      uploadFileService('motherCertificate', formik.values.compPhoto1);
    }
  };

  const formik = useFormik({
    initialValues: secondState,
    validationSchema: validationSchema,
    onSubmit,
  });

  if (
    formik &&
    formik.values &&
    Object.keys(formik.errors).length === 0 &&
    formik.values &&
    formik.values.fatherName &&
    formik.values.motherName &&
    formik.values.phone &&
    formik.values.phone1
  ) {
    isDisabled = false;
  }

  const handleUpdateFileInfo = (file, fileName, imagePreviewUrl) => {
    formik.values.compPhoto = file;
    formik.values.fileName = fileName;
    formik.values.imagePreviewUrl = imagePreviewUrl;
    // setFileUploadedTime(new Date());
  };

  const handleUpdateFileInfo1 = (file, fileName, imagePreviewUrl) => {
    formik.values.compPhoto1 = file;
    formik.values.fileName1 = fileName;
    formik.values.imagePreviewUrl1 = imagePreviewUrl;
    //setFileUploadedTime(new Date());
  };

  return (
    <Box>
      <div>
        <Grid container spacing={4}>
          <Grid item xs={12} sm={6}>
            <Typography variant="h5">Father Details</Typography>
            <br />
            <Typography
              variant={'subtitle2'}
              sx={{ marginBottom: 2 }}
              fontWeight={700}
            >
              Father Name*
            </Typography>
            <TextField
              label="Enter Father Name"
              variant="outlined"
              name={'fatherName'}
              fullWidth
              defaultValue={formik.values && formik.values.fatherName}
              onChange={formik.handleChange('fatherName')}
              error={
                formik.touched.fatherName || Boolean(formik.errors.fatherName)
              }
              helperText={formik.touched.fatherName || formik.errors.fatherName}
            />
            As per Aadhar card/Passport
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="h5">Mother Details</Typography>
            <br />
            <Typography
              variant={'subtitle2'}
              sx={{ marginBottom: 2 }}
              fontWeight={700}
            >
              Mother Name*
            </Typography>
            <TextField
              label="Enter Mother Name"
              variant="outlined"
              name={'motherName'}
              fullWidth
              defaultValue={formik.values && formik.values.motherName}
              onChange={formik.handleChange('motherName')}
              error={
                formik.touched.motherName || Boolean(formik.errors.motherName)
              }
              helperText={formik.touched.motherName || formik.errors.motherName}
            />
            As per Aadhar card/Passport
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography
              variant={'subtitle2'}
              sx={{ marginBottom: 2 }}
              fontWeight={700}
            >
              Mobile Number*
            </Typography>
            <TextField
              label="Enter Father Mobile Number"
              variant="outlined"
              name={'phone'}
              fullWidth
              defaultValue={formik.values && formik.values.phone}
              onChange={formik.handleChange('phone')}
              error={formik.touched.phone || Boolean(formik.errors.phone)}
              helperText={formik.touched.phone || formik.errors.phone}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography
              variant={'subtitle2'}
              sx={{ marginBottom: 2 }}
              fontWeight={700}
            >
              Mobile Number*
            </Typography>
            <TextField
              label=" Enter Mother Mobile Number"
              variant="outlined"
              name={'phone1'}
              fullWidth
              defaultValue={formik.values && formik.values.phone1}
              onChange={formik.handleChange('phone1')}
              error={formik.touched.phone1 || Boolean(formik.errors.phone1)}
              helperText={formik.touched.phone1 || formik.errors.phone1}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography
              variant={'subtitle2'}
              sx={{ marginBottom: 2 }}
              fontWeight={700}
            >
              Father Email Id*
            </Typography>
            <TextField
              label=" Enter Father email id"
              variant="outlined"
              name={'email'}
              fullWidth
              defaultValue={formik.values && formik.values.email}
              onChange={formik.handleChange('email')}
              error={formik.touched.email || Boolean(formik.errors.email)}
              helperText={formik.touched.email || formik.errors.email}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography
              variant={'subtitle2'}
              sx={{ marginBottom: 2 }}
              fontWeight={700}
            >
              Mother email id*
            </Typography>
            <TextField
              label=" Enter Mother email id"
              variant="outlined"
              name={'email1'}
              fullWidth
              defaultValue={formik.values && formik.values.email1}
              onChange={formik.handleChange('email1')}
              error={formik.touched.email1 || Boolean(formik.errors.email1)}
              helperText={formik.touched.email1 || formik.errors.email1}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant={'subtitle2'} sx={{ marginBottom: 2 }}>
              Father Mother Tongue*
            </Typography>
            <TextField
              select
              label="Select Mother Tongue"
              variant="outlined"
              name={'fatherLang'}
              fullWidth
              defaultValue={formik.values && formik.values.fatherLang}
              onChange={formik.handleChange('fatherLang')}
              error={
                formik.touched.fatherLang || Boolean(formik.errors.fatherLang)
              }
              helperText={formik.touched.fatherLang || formik.errors.fatherLang}
            >
              {[
                'Select Mother Toungue',
                'Kannada',
                'Hindi',
                'Telgu',
                'Tamil',
                'English',
                'Marati',
                'Gujarati',
                'Malyalam',
                'Assam',
                'Others',
              ].map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant={'subtitle2'} sx={{ marginBottom: 2 }}>
              Mother mother Tongue*
            </Typography>
            <TextField
              select
              label="Select Mother Tongue"
              variant="outlined"
              name={'motherLang*'}
              fullWidth
              defaultValue={formik.values && formik.values.motherLang}
              onChange={formik.handleChange('motherLang')}
              error={
                formik.touched.motherLang || Boolean(formik.errors.motherLang)
              }
              helperText={formik.touched.motherLang || formik.errors.motherLang}
            >
              {[
                'Select Mother Toungue',
                'Kannada',
                'Hindi',
                'Telgu',
                'Tamil',
                'English',
                'Marati',
                'Gujarati',
                'Malyalam',
                'Assam',
                'Others',
              ].map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography
              variant={'subtitle2'}
              sx={{ marginBottom: 2 }}
              fontWeight={700}
            >
              Residential Address*
            </Typography>
            <TextField
              label="Enter Residential Address"
              variant="outlined"
              name={'resadd'}
              fullWidth
              defaultValue={formik.values && formik.values.resadd}
              onChange={formik.handleChange('resadd')}
              error={formik.touched.resadd || Boolean(formik.errors.resadd)}
              helperText={formik.touched.resadd || formik.errors.resadd}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography
              variant={'subtitle2'}
              sx={{ marginBottom: 2 }}
              fontWeight={700}
            >
              Residential Address*
            </Typography>
            <TextField
              key={`res-${formik.values && formik.values.address}`}
              label="Enter Residential Address"
              variant="outlined"
              name={'resadd1'}
              fullWidth
              defaultValue={
                formik.values && formik.values.address
                  ? formik.values && formik.values.resadd
                  : formik.values && formik.values.resadd1
              }
              onChange={formik.handleChange('resadd1')}
              error={formik.touched.resadd1 || Boolean(formik.errors.resadd1)}
              helperText={formik.touched.resadd1 || formik.errors.resadd1}
            />
            <Box>
              <Typography marginLeft={22}>
                Same as Father's Details
                <Checkbox
                  color="primary"
                  id="address"
                  name="address"
                  defaultChecked={formik.values && formik.values.address}
                  onChange={formik.handleChange}
                  marginLeft={22}
                />
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Typography
              variant={'subtitle2'}
              sx={{ marginBottom: 2 }}
              fontWeight={700}
            >
              Residential Number
            </Typography>
            <TextField
              label="Enter Residential Number"
              variant="outlined"
              name={'resnum'}
              fullWidth
              defaultValue={formik.values && formik.values.resnum}
              onChange={formik.handleChange}
              error={formik.touched.resnum || Boolean(formik.errors.resnum)}
              helperText={formik.touched.resnum || formik.errors.resnum}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <Typography
              variant={'subtitle2'}
              sx={{ marginBottom: 2 }}
              fontWeight={700}
            >
              Residential Number
            </Typography>
            <TextField
              key={`res-${formik.values && formik.values.address}`}
              label="Enter Residential Number"
              variant="outlined"
              name={'resnum1'}
              fullWidth
              defaultValue={
                formik.values && formik.values.address
                  ? formik.values && formik.values.resnum
                  : formik.values && formik.values.resnum1
              }
              onChange={formik.handleChange}
              error={formik.touched.resnum1 || Boolean(formik.errors.resnum1)}
              helperText={formik.touched.resnum1 || formik.errors.resnum1}
            />
          </Grid>

          <Grid item xs={12} sm={3}>
            <Typography
              variant={'subtitle2'}
              sx={{ marginBottom: 2 }}
              fontWeight={700}
            >
              Area*
            </Typography>
            <TextField
              label="Enter Area"
              variant="outlined"
              name={'area'}
              fullWidth
              defaultValue={formik.values && formik.values.area}
              onChange={formik.handleChange('area')}
              error={formik.touched.area || Boolean(formik.errors.area)}
              helperText={formik.touched.area || formik.errors.area}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <Typography
              variant={'subtitle2'}
              sx={{ marginBottom: 2 }}
              fontWeight={700}
            >
              District*
            </Typography>
            <TextField
              label="Enter District"
              variant="outlined"
              name={'dist'}
              fullWidth
              defaultValue={formik.values && formik.values.dist}
              onChange={formik.handleChange}
              error={formik.touched.dist || Boolean(formik.errors.dist)}
              helperText={formik.touched.dist || formik.errors.dist}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <Typography
              variant={'subtitle2'}
              sx={{ marginBottom: 2 }}
              fontWeight={700}
            >
              Area*
            </Typography>
            <TextField
              key={`res-${formik.values && formik.values.address}`}
              label="Enter Area"
              variant="outlined"
              name={'area1'}
              fullWidth
              defaultValue={
                formik.values && formik.values.address
                  ? formik.values && formik.values.area
                  : formik.values && formik.values.area1
              }
              onChange={formik.handleChange}
              error={formik.touched.area1 || Boolean(formik.errors.area1)}
              helperText={formik.touched.area1 || formik.errors.area1}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <Typography
              variant={'subtitle2'}
              sx={{ marginBottom: 2 }}
              fontWeight={700}
            >
              District*
            </Typography>
            <TextField
              key={`res-${formik.values && formik.values.address}`}
              label="Enter District"
              variant="outlined"
              name={'dist1'}
              fullWidth
              defaultValue={
                formik.values && formik.values.address
                  ? formik.values && formik.values.dist
                  : formik.values && formik.values.dist1
              }
              onChange={formik.handleChange}
              error={formik.touched.dist1 || Boolean(formik.errors.dist1)}
              helperText={formik.touched.dist1 || formik.errors.dist1}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <Typography
              variant={'subtitle2'}
              sx={{ marginBottom: 2 }}
              fontWeight={700}
            >
              State*
            </Typography>
            <TextField
              label="Enter State"
              variant="outlined"
              name={'state'}
              fullWidth
              defaultValue={formik.values && formik.values.state}
              onChange={formik.handleChange}
              error={formik.touched.state || Boolean(formik.errors.state)}
              helperText={formik.touched.state || formik.errors.state}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <Typography variant={'subtitle2'} sx={{ marginBottom: 2 }}>
              Country*
            </Typography>
            <TextField
              select
              label="Select Country"
              variant="outlined"
              name={'country'}
              fullWidth
              defaultValue={formik.values && formik.values.country}
              onChange={formik.handleChange}
              error={formik.touched.country || Boolean(formik.errors.country)}
              helperText={formik.touched.country || formik.errors.country}
            >
              {[
                'Select Country',
                'India',
                'America',
                'Australia',
                'Brazil',
                'Canada',
                'Germany',
                'France',
                'Italy',
                'Others',
              ].map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12} sm={3}>
            <Typography
              variant={'subtitle2'}
              sx={{ marginBottom: 2 }}
              fontWeight={700}
            >
              State*
            </Typography>
            <TextField
              key={`res-${formik.values && formik.values.address}`}
              label="Enter State"
              variant="outlined"
              name={'state1'}
              fullWidth
              defaultValue={
                formik.values && formik.values.address
                  ? formik.values && formik.values.state
                  : formik.values && formik.values.state1
              }
              onChange={formik.handleChange}
              error={formik.touched.state1 || Boolean(formik.errors.state1)}
              helperText={formik.touched.state1 || formik.errors.state1}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <Typography variant={'subtitle2'} sx={{ marginBottom: 2 }}>
              Country*
            </Typography>
            <TextField
              select
              key={`res-${formik.values && formik.values.address}`}
              label="Select Country"
              variant="outlined"
              name={'country1'}
              fullWidth
              defaultValue={
                formik.values && formik.values.address
                  ? formik.values && formik.values.country
                  : formik.values && formik.values.country1
              }
              onChange={formik.handleChange}
              error={formik.touched.country1 || Boolean(formik.errors.country1)}
              helperText={formik.touched.country1 || formik.errors.country1}
            >
              {[
                'Select Country',
                'India',
                'America',
                'Australia',
                'Brazil',
                'Canada',
                'Germany',
                'France',
                'Italy',
                'Others',
              ].map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={6} sm={6}>
            <Typography
              variant={'subtitle2'}
              sx={{ marginBottom: 2 }}
              fontWeight={700}
            >
              Pincode*
            </Typography>
            <TextField
              label="Enter Pincode"
              variant="outlined"
              name={'pin'}
              fullWidth
              defaultValue={formik.values && formik.values.pin}
              onChange={formik.handleChange}
              error={formik.touched.pin || Boolean(formik.errors.pin)}
              helperText={formik.touched.pin || formik.errors.pin}
            />
          </Grid>
          <Grid item xs={6} sm={6}>
            <Typography
              variant={'subtitle2'}
              sx={{ marginBottom: 2 }}
              fontWeight={700}
            >
              Pincode*
            </Typography>
            <TextField
              key={`res-${formik.values && formik.values.address}`}
              label="Enter Pincode"
              variant="outlined"
              name={'pin1'}
              fullWidth
              defaultValue={
                formik.values && formik.values.address
                  ? formik.values && formik.values.pin
                  : formik.values && formik.values.pin1
              }
              onChange={formik.handleChange}
              error={formik.touched.pin1 || Boolean(formik.errors.pin1)}
              helperText={formik.touched.pin1 || formik.errors.pin1}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography>
              Working
              <Checkbox
                color="primary"
                id="working"
                name="working"
                defaultChecked={formik.values && formik.values.working}
                onChange={formik.handleChange}
              />
            </Typography>

            <TextField
              select
              label="Enter Designation"
              variant="outlined"
              disabled={!(formik.values && formik.values.working)}
              name={'designation'}
              fullWidth
              defaultValue={formik.values && formik.values.designation}
              onChange={formik.handleChange('designation')}
            >
              {[
                'Public Sector',
                'Public Sector',
                'Public Sector',
                'Public Sector',
                'Others',
              ].map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Typography>
              Working
              <Checkbox
                color="primary"
                id="working1"
                name="working1"
                defaultChecked={formik.values && formik.values.working1}
                onChange={formik.handleChange}
              />
            </Typography>

            <TextField
              select
              label="Enter Designation"
              variant="outlined"
              disabled={!(formik.values && formik.values.working1)}
              name={'designation1'}
              fullWidth
              defaultValue={formik.values && formik.values.designation1}
              onChange={formik.handleChange('designation1')}
            >
              {[
                'Public Sector',
                'Public Sector',
                'Public Sector',
                'Public Sector',
                'Others',
              ].map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Enter Company"
              variant="outlined"
              disabled={!(formik.values && formik.values.working)}
              name={'company'}
              fullWidth
              defaultValue={formik.values && formik.values.company}
              onChange={formik.handleChange('company')}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              label="Enter Company"
              variant="outlined"
              disabled={!(formik.values && formik.values.working1)}
              name={'company1'}
              fullWidth
              defaultValue={formik.values && formik.values.company1}
              onChange={formik.handleChange('company1')}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              label="Enter Company Address"
              variant="outlined"
              disabled={!(formik.values && formik.values.working)}
              name={'companyAdd'}
              fullWidth
              defaultValue={formik.values && formik.values.companyAdd}
              onChange={formik.handleChange('companyAdd')}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              label="Enter Company Address"
              variant="outlined"
              disabled={!(formik.values && formik.values.working1)}
              name={'companyAdd1'}
              fullWidth
              defaultValue={formik.values && formik.values.companyAdd1}
              onChange={formik.handleChange('companyAdd1')}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              label="Enter Office Number"
              variant="outlined"
              disabled={!(formik.values && formik.values.working)}
              name={'offnum'}
              fullWidth
              defaultValue={formik.values && formik.values.offnum}
              onChange={formik.handleChange('offnum')}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              label="Enter Office Number"
              variant="outlined"
              disabled={!(formik.values && formik.values.working1)}
              name={'offnum1'}
              fullWidth
              defaultValue={formik.values && formik.values.offnum1}
              onChange={formik.handleChange('offnum1')}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <Typography
              variant={'subtitle2'}
              sx={{ marginBottom: 2 }}
              fontWeight={700}
              disabled={!(formik.values && formik.values.working)}
            >
              Upload company cert(Father)*
            </Typography>

            <FileUploadViewer
              disabled={!(formik.values && formik.values.working)}
              file={formik.values && formik.values.compPhoto}
              info={`stepone`}
              fileName={formik.values && formik.values.fileName}
              imagePreviewUrl={formik.values && formik.values.imagePreviewUrl}
              handleUpdateFileInfo={handleUpdateFileInfo}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <Typography
              variant={'subtitle2'}
              sx={{ marginBottom: 2 }}
              fontWeight={700}
              disabled={!(formik.values && formik.values.working1)}
            >
              Upload company cert(Mother)*
            </Typography>

            <FileUploadViewer
              disabled={!(formik.values && formik.values.working1)}
              file={formik.values && formik.values.compPhoto1}
              info={`stepone1`}
              fileName={formik.values && formik.values.fileName1}
              imagePreviewUrl={formik.values && formik.values.imagePreviewUrl1}
              handleUpdateFileInfo={handleUpdateFileInfo1}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <Typography
              variant={'subtitle2'}
              sx={{ marginBottom: 2 }}
              fontWeight={700}
            >
              Gross Annual Income (INR)*
            </Typography>
            <TextField
              label="Enter Gross Annual Income"
              variant="outlined"
              name={'gross'}
              fullWidth
              defaultValue={formik.values && formik.values.gross}
              onChange={formik.handleChange}
              error={formik.touched.gross || Boolean(formik.errors.gross)}
              helperText={formik.touched.gross || formik.errors.gross}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography
              variant={'subtitle2'}
              sx={{ marginBottom: 2 }}
              fontWeight={700}
            >
              Gross Annual Income (INR)*
            </Typography>
            <TextField
              label="Enter Gross Annual Income"
              variant="outlined"
              name={'gross1'}
              fullWidth
              defaultValue={formik.values && formik.values.gross1}
              onChange={formik.handleChange}
              error={formik.touched.gross1 || Boolean(formik.errors.gross1)}
              helperText={formik.touched.gross1 || formik.errors.gross1}
            />
          </Grid>

          <Box
            component={Button}
            variant="contained"
            color="primary"
            size="large"
            type="submit"
            height={54}
            //   href='/not-found-cover'
            marginTop={{ xs: 8, sm: 9 }}
            marginLeft={{ sm: 40 }}
          >
            <span onClick={() => handleCurrentStep(1)}>Go Back</span>
          </Box>

          <Box
            component={Button}
            variant="contained"
            color="primary"
            size="large"
            type="submit"
            height={54}
            marginTop={{ xs: 8, sm: 9 }}
            marginLeft={{ sm: 4 }}
            disabled={isDisabled}
            readOnly={isDisabled}
            onClick={onSubmit}
            // href = '/startup'
          >
            Save & Continue
          </Box>
        </Grid>
      </div>
    </Box>
  );
};

export default SecondStep;